<template>
  <div class="homepage-view">
    <!-- Custom Home: InVadobay -->
    <invadobay-view
      v-if="custom_home_invadobay_slug && is_authenticated()"
      :slug="custom_home_invadobay_slug"
      :is_custom_home="true"
    />

    <!-- Homepage Standard -->
    <template v-else>
    <section class="section section--slider">
      <swiper-container
        init="false"
        ref="swiper-container"
        class="section--slider-main"
        pagination="true"
      >
        <swiper-slide
          v-for="(item, item_index) in slider_items"
          :key="_uid + item_index"
          class="section--slider-item"
          :class="{ overlay: item.overlay }"
        >
          <div
            class="section--slider-image"
            :style="'background-image:url(' + item.wallpaper + ')'"
          />
          <b-container class="captions">
            <vb-icon
              :name="'symbol_lb'"
              :size="36"
              class="icon"
              :color="'#999999'"
            />
            <div class="text">
              <div class="vb-heading h2" v-html="item.title" />
              <div class="text-md" v-html="item.text" />
            </div>
          </b-container>
        </swiper-slide>
      </swiper-container>
      <vb-icon
        :name="'angle_left'"
        :color="'000'"
        :size="18"
        class="section--slider-nav section--slider-nav--prev"
        @click="swiper_instance.swiper.slidePrev()"
      />
      <vb-icon
        :name="'angle_right'"
        :color="'000'"
        :size="18"
        class="section--slider-nav section--slider-nav--next"
        @click="swiper_instance.swiper.slideNext()"
      />
      <div class="custom-pagination">
        <div
          class="custom-pagination-item"
          v-for="(item, item_index) in Array.from(
            { length: slider_items.length / 2 },
            (_, i) => i
          )"
          :key="_uid + item_index"
          :class="{ active: slider_index == item_index }"
        />
      </div>
    </section>

    <!--booking engine-->
    <section class="section section--booking-engine" v-if="is_authenticated()">
      <b-container>
        <booking-engine
          @search="
            () => {
              $store.commit('liveeps/selected_invadobay', {})
              this.$router.push({ name: 'results' });
            }
          "
        />
      </b-container>
    </section>

    <!--loader-->
    <section
      class="section section--loader"
      v-if="is_authenticated() && searching"
    >
      <loader size="large" :show_timing_slot="true" />
    </section>

    <!--token expired-->
    <token-expired
      class="section section--token-expired"
      v-if="!is_authenticated()"
    >
      <!--<template v-slot:header />-->
      <!--<template v-slot:content />-->
      <template v-if="is_vivamod()" #content>
        <b-container>
          <h3 class="h3 text-center">
            <strong>Vivamod</strong> è una piattaforma sviluppata da Salabam
            Solutions, perfetta per clienti che vogliono integrare al proprio
            ecosistema aziendale un sito di viaggi che può essere ampiamente
            personalizzato. <br /><br />
            <strong>
              Forniamo una tecnologia rodata e già utilizzata da centinaia di
              aziende. Per fare viaggiare i tuoi migliori clienti, contattaci.
            </strong>
          </h3>
        </b-container>
      </template>
      <!--<template v-slot:footer />-->
    </token-expired>

    <!-- invadobay -->
    <invadobays v-if="is_authenticated()" /> 

    <sections :brand="$config.site.brand" />

    <div class="sections">
      <!--suggestions-->
      <section class="section" v-if="false /*suggestions*/">
        <b-container>
          <!--<suggestions :suggestions="suggestions" :autoplay="suggestions_autoplay_speed"/>-->
          <suggestions :autoplay="suggestions_autoplay_speed" />
        </b-container>
      </section>
    </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TokenExpired from "@components/blocks/token-expired.vue";
import Suggestions from "@liveeps/components/blocks/suggestions.vue";
import { get_config, is_authenticated } from "@src/utilities";
import { md } from "@running_app_src/scss/abstract/_custom.scss";
import Sections from "@components/blocks/sections/sections.vue";
import Invadobays from "@liveeps/components/blocks/invadobay/invadobays.vue";
import InvadobayView from "@liveeps/components/views/invadobay.vue";

export default {
  name: "homepage-view",

  components: {
    "token-expired": TokenExpired,
    suggestions: Suggestions,
    sections: Sections,
    "invadobays": Invadobays,
    "invadobay-view": InvadobayView,
  },

  props: {
  },

  data() {
    return { 
      slider_items: this.get_slider_items(),
      slider_index: 0,
      suggestions: get_config("searchSuggestions", []),
      suggestions_autoplay_speed: get_config(
        "guiSettings.autoplaySpeedSuggestions",
        0
      ),
      swiper_instance: {},
      swiper_params: {
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        breakpoints: {
          [md.replace(/[^\d.]+/g, "")]: {
            slidesPerView: 2,
          },
        },
        on: {
          init: (s) => {
            // forzo l'aggiornamento senza cambiare slide per aggiornare la autoHeight
            // s.slideTo(0)
            // aggiorno slider_index per avere l'active nella paginazione
            this.slider_index = s.realIndex;
            // aggiorno l'istanza in base al numero di slides:
            // se loopedSlides==1 sono nel mobile (default: chiamo la update() ma di fatto non succede niente)
            // se loopedSlides==2 sono nel desktop e devo manipolare l'ordine delle slides per mostrare correttamente l'ultima in trasparenza
            this.slider_items = this.get_slider_items(s.loopedSlides);
            s.update();
          },
          /*
          slideChange: event => {
            // aggiorno slider_index per avere l'active nella paginazione
            this.slider_index = event.realIndex
          },
          */
          slidePrevTransitionStart: () => {
            if (this.slider_index == 0)
              this.slider_index = this.slider_items.length / 2 - 1;
            else this.slider_index = this.slider_index - 1;
          },
          slideNextTransitionStart: () => {
            if (this.slider_index == this.slider_items.length / 2 - 1)
              this.slider_index = 0;
            else this.slider_index = this.slider_index + 1;
          },
        },
      },
    };
  },

  computed: {
    ...mapState("liveeps", ["searching", "selected_invadobay"]),
    custom_home_invadobay_slug() {
      const homepage = get_config('guiSettings.customizations.homepage')
      if (!homepage || homepage.component !== 'in-vadobay') {
        return null
      }
      const { slug } = homepage.props || {}
      return slug
    },
  },

  created() {
    this.log(this.is_vivamod());
    // clean up state on creation
    if (Object.keys(this.selected_invadobay).length > 0) {
      this.$store.commit('liveeps/selected_invadobay', {})
      this.$store.commit("liveeps/location",  {
        label: "",
        latitude: "",
        longitude: "",
        matchLevel: "",
      }); 
    }
  },

  mounted() {
    // Skip swiper initialization when custom home is active
    if (this.custom_home_invadobay_slug && is_authenticated()) return

    const swiper_instance = this.$refs["swiper-container"];
    Object.assign(swiper_instance, this.swiper_params);
    swiper_instance.initialize();
    this.swiper_instance = swiper_instance;
  },

  methods: { 
    get_slider_items(slides = 1) {
      let items = is_authenticated()
        ? get_config("sliderHome.private", [])
        : get_config("sliderHome.public", []);
      if (slides == 1) return items;
      let last = items.pop();
      return [last, ...items, last, ...items];
    },
  },
}
</script>

<style lang="scss" scoped>

  .section {

    &--slider {
      position: relative;
      margin-top: 0;

      @include media-breakpoint-up(md) {
        margin-bottom: 0;
      }

      &-item {
        position: relative;
      }

      &-image {
        background-size: cover;
        background-position: center center;
        height: 280px;

        @include media-breakpoint-up(md) {
          height: 320px;
        }
        @include media-breakpoint-up(lg) {
          height: 360px;
        }
      }

      &-nav {
        position: absolute;
        z-index: 1;
        top: 130px;
        transform: translateY(-50%);
        padding: $grid-gutter-width/2;
        cursor: pointer;

        &--prev {
          left: 0;

          ::v-deep {
            svg {
              filter: drop-shadow(-2px 0 0 $white);
            }
          }
        }

        &--next {
          right: 0;

          ::v-deep {
            svg {
              filter: drop-shadow(2px 0 0 $white);
            }
          }
        }

        @include media-breakpoint-up(md) {
          top: 50%;
        }
      }
      .captions {
        margin-top: $grid-gutter-width/2;
        display: flex;

        .icon {
          padding-top: 3px;
        }

        .text {
          padding-left: $grid-gutter-width/2;
          color: $dark;

          * {
            line-height: 120%;
          }

          .vb-heading {
            margin-bottom: 4px;
            color: $dark;
            line-height: 110%;
          }
        }

        @include media-breakpoint-between(md, lg) {
          padding-left: 16% !important;

          .vb-heading {
            font-size: 30px !important;
            max-width: 90% !important;
          }
        }
      }

      .custom-pagination {
        display: none;
        position: absolute;
        z-index: 1;
        bottom: 100px;
        left: calc(2.5% + 36px + #{$grid-gutter-width/2}); // margine sinistro + larghezza icona + padding contenitore captions

        &-item {
          margin-right: 10px;
          height: 2px;
          width: 30px;
          background: $gray-500;
          &.active {
            background: $gray-600;
          }
        }
      }

      @include media-breakpoint-up(md) {
        &-item {

          &:after {
            content: "";
            position: absolute;
            background: rgba($white, 0.9);
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            transition: $transition-base;
            opacity: 0;
          }
        }

        .custom-pagination {
          display: flex;
          margin-left: 10.5%;
        }

        .swiper-slide-active {

          .captions {
            display: none;
          }

          &:after {
            opacity: 1;
          }
        }

        .swiper-slide-next {
          position: relative;

          .captions {
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            transform: translateY(-50%) translateX(-100%);
            margin-top: 0;
            padding: 0 $grid-gutter-width 0 26%;

            .text-md {
              font-size: 18px;
            }

            .vb-heading {
              font-size: 36px;
              line-height: 120%;
            }

            .icon {
              padding-top: 8px;
            }
          }
        }
      }
    }

    &--booking-engine {
      position: relative;
      z-index: 1;

      @include media-breakpoint-up(md) {
        margin-top: -33px;
      }
    }

    &--token-expired {
      margin-top: $grid-gutter-width * 2;
    }
  }

  .sections > .section {

    @include media-breakpoint-up(lg) {
      margin-top: 100px;

      &:last-child {
        margin-bottom: 100px;
      }
    }
  }
</style>
